/**
 * @generated SignedSource<<e9182903e6e1a1dddef24758eedc7336>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorToolbar_text$data = {
  readonly blocks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly data: string | null;
        readonly locale: Locale;
        readonly " $fragmentSpreads": FragmentRefs<"EditorTranslateButton_textBlock">;
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EditorLanguageButton_text">;
  readonly " $fragmentType": "EditorToolbar_text";
};
export type EditorToolbar_text$key = {
  readonly " $data"?: EditorToolbar_text$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorToolbar_text">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorToolbar_text",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TextBlockConnection",
      "kind": "LinkedField",
      "name": "blocks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TextBlockEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TextBlock",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "locale",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EditorTranslateButton_textBlock"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorLanguageButton_text"
    }
  ],
  "type": "Text",
  "abstractKey": null
};

(node as any).hash = "cb086112827e6b4e42de6f82f102f894";

export default node;
